/* unplugin-vue-components disabled */import { render } from "./IosPage.vue?vue&type=template&id=3611b3c7&scoped=true"
import script from "./IosPage.vue?vue&type=script&lang=js"
export * from "./IosPage.vue?vue&type=script&lang=js"

import "./IosPage.vue?vue&type=style&index=0&id=3611b3c7&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3611b3c7"]])

export default __exports__